import "@popperjs/core";
import('bootstrap');
import * as bootstrap from 'bootstrap';
window.bootstrap = bootstrap;

//popovers website
let popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
let popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
})